//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../goods/goods.less'
import orderJS from './order.js'
export default {
    props: ['activeIndex'],
    mixins: [orderJS],
    data() {
        return {
            currentPage: 1,
            pageSize: 5,
            dataList: [],
            lastPage: false,
            statusList: ['', 'payWaiting', 'shipWaiting', 'receivWaiting', 'afterSale'],
        }
    },
    methods: {
        /**
         * type: 1赋值，2push
         */
        loadList(type, done) {
            let that = this;
            let searchItem = {
                currentPage: that.currentPage,
                pageSize: that.pageSize,
                shopperId: that.$store.state.userInfo.shopperId,
                status: that.statusList[that.activeIndex],
            }
            that.$axios.get('/api/v1.0/lonbonShop/order', {
                params: searchItem
            }).then(function (response) {
                if(response.status == 200) {
                    var list = response.body.list.map((item) => {
                        item.orderStatusStr = that.$store.state.dict.statusStrList[item.status].title;
                        return item;
                    });
                    if(type == 1) {
                        that.dataList = list;
                    } else {
                        list.forEach((item) => {
                            that.dataList.push(item);
                        })
                    }
                    done&&done(true);
                } else if(response.status == 203) {
                    that.lastPage = true;
                    that.$refs.orderScrollerRef.finishInfinite(true);
                }
            })
        },
        doNext(done) {
            if(!this.lastPage) {
                this.currentPage++;
                this.loadList(2, done);
            } else {
                done&&done(true);
            }
        },
        doRefresh(done) {
            this.currentPage = 1;
            this.loadList(1);
            this.lastPage = false;
            setTimeout(() => {
                done&&done(true);
            }, 1000);
        },
        //查看订单详情
        toOrder(id) {
            this.$router.push("/orderDetail?readyPayOrderId="+id+"&activeIndex="+this.activeIndex);
        },
        //查看订单详情并支付
        toOrderAndPay(id) {
            this.$router.push("/orderDetail?readyPayOrderId="+id+"&openPay=true&activeIndex="+this.activeIndex);
        },
        //取消订单
        cancleOrder(one, index) {
            let that = this;
            that.cancleOrderFunc(one, function() {
                if(that.activeIndex == 0) {
                    that.dataList[index].status = 9;
                    that.dataList[index].orderStatusStr = that.$store.state.dict.statusStrList[9].title;
                } else {
                    that.dataList.splice(index, 1);
                }
                that.dataList = JSON.parse(JSON.stringify(that.dataList));
            })
        },
        //删除订单
        deleteOrder(one, index) {
            let that = this;
            that.deleteOrderFunc(one, function() {
                that.dataList.splice(index, 1);
                that.dataList = JSON.parse(JSON.stringify(that.dataList));
            })
        },
        //确认收货
        sureTake(one, index) {
            let that = this;
            that.sureTakeFunc(one, function() {
                if(that.activeIndex == 0) {
                    that.dataList[index].status = 3;
                    that.dataList[index].orderStatusStr = that.$store.state.dict.statusStrList[3].title;
                } else {
                    that.dataList.splice(index, 1);
                }
                that.dataList = JSON.parse(JSON.stringify(that.dataList));
            })
        }
    },
    mounted() {
        this.doRefresh();
    }
}



// WEBPACK FOOTER //
// ./src/components/order/list.vue